import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";
const borderColor = '#F5F5F5'
const styles = StyleSheet.create({
  headerContainer: {
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    backgroundColor: '#F9F9F9',
  },
  billTo: {
    color: '#000',
    fontSize: 9,
    lineHeight: 1.5,
    marginBottom: 2,
  },
  cancellationpolicy: {
    color: '#333',
    fontSize: 6.5,
    lineHeight: 1.4,
    fontWeight: 300,
    marginLeft: 6,
    fontStyle: 'italic',
  },
});

let CancellationModal = (data, StartDate) => {
  return (
    <Text>
      {data.map((i, index) => {
        const date = new Date(StartDate);
        date.setDate(date.getDate() - i.day_before_arrival);

        let DataNew = moment(date).format("Do MMM YYYY");
        let Value = "";
        let EuroIcon = "";
        let PerIcon = "";

        if (i.penalty === "No Penalty") {
          Value = 0;
        } else if (i.penalty === "Full Amount") {
          PerIcon = "Full booking amount will be charged. ";
        } else if (i.penalty === "Percentage") {
          Value = i.cancellation_value;
          PerIcon = "% of booking amount will be charged. ";
        } else if (i.penalty === "Nights" || i.penalty === "Fixed Amount") {
          Value = i.cancellation_value;
          EuroIcon = "€";
          PerIcon = " amount will be charged. ";
        }

        if (i.day_before_arrival === -1) {
          DataNew = "No Show";
        }

        return (
          <Text key={index}>
            <Text style={styles.cancellationpolicy}>
              {index === 0 ? "Before" : "After"} {DataNew},
            </Text>
            <Text style={styles.cancellationpolicy}>
              {EuroIcon} {Value} {PerIcon}
            </Text>
          </Text>
        );
      })}
    </Text>
  );
};

const CancellationAccommodation = ({invoice}) => {
  const startDate = invoice.booking_checked_in;
  const items = JSON.parse(JSON.parse(JSON.stringify(invoice?.cancellation_policy)));

  const rowsCancel = items && items.slice(0, 1).map((item, idx) => (
    <Text key={idx} style={styles.billTo}>
      {CancellationModal(item, startDate)} <br/>
    </Text>
  ));

  return (
    <View style={styles.headerContainer}>
      <Text style={{
    fontSize: 10,
    // lineHeight: 1.5,
    marginBottom: 8,
    
   }}>Cancellation Policy:</Text>
      {rowsCancel}
    </View>
  );
};

export default CancellationAccommodation;
